module.exports = __webpack_public_path__ + "static/media/pic4.9fd0ff01.jpg";